module.exports = __webpack_public_path__ + "assets/e6db08e7bfc3c2cf03af8d0bea4e129f.jpg";